import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CALCULATION_VEHICLE_INSURANCE_EDIT_FORM_SCHEMA = yup.object().shape({
  fromKw: yup.string().required('Molimo Vas da unesite kw od'),
  toKw: yup.string().required('Molimo Vas da unesite kw do'),
  price: yup.string().required('Molimo Vas da unesete cijenu'),
});

